import { render } from "./RecentCourses.vue?vue&type=template&id=359ddb60&scoped=true"
import script from "./RecentCourses.vue?vue&type=script&lang=js"
export * from "./RecentCourses.vue?vue&type=script&lang=js"

import "./RecentCourses.vue?vue&type=style&index=0&id=359ddb60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359ddb60"]])

export default __exports__